module.exports = __webpack_public_path__ + "img/fdc0bc24781c5d6ac1118b3fc894f7f5.png";